export const GENERATE_SHIPMENT_CHARGES_REQUEST = "GENERATE_SHIPMENT_CHARGES_REQUEST";
export const GENERATE_SHIPMENT_CHARGES_SUCCESS = "GENERATE_SHIPMENT_CHARGES_SUCCESS";
export const GENERATE_SHIPMENT_CHARGES_FAILURE = "GENERATE_SHIPMENT_CHARGES_FAILURE";
export const GENERATE_SHIPMENT_CHARGES_RESET = "GENERATE_SHIPMENT_CHARGES_RESET";
export const generateShipmentChargesRequest = (payload) => ({
    type: GENERATE_SHIPMENT_CHARGES_REQUEST,
    payload,
});
export const generateShipmentChargesSuccess = (payload) => ({
    type: GENERATE_SHIPMENT_CHARGES_SUCCESS,
    payload,
});
export const generateShipmentChargesFailure = (error) => ({
    type: GENERATE_SHIPMENT_CHARGES_FAILURE,
    payload: error,
});
export const generateShipmentChargesReset = () => ({
    type: GENERATE_SHIPMENT_CHARGES_RESET,
});
